import BillOfMaterialDetailTable from './BillOfMaterialDetailTable';
import BillOfMaterialDetailHeaderFilter from './BillOfMaterialDetailHeaderFilter';

const BillOfMaterialDetail = () => {
  return (
    <>
      <div className={'page-wrapper'}>
        <BillOfMaterialDetailHeaderFilter />
        <BillOfMaterialDetailTable />
      </div>
    </>
  );
};

export default BillOfMaterialDetail;
